import React from 'react';
import SpotIllustration from '../shared/SpotIllustration';

const SearchUnavailableIllustration = () => {
	const searchUnavailableSvg = (
		<SpotIllustration
			spotName="search-unavailable"
			spotWidth="236"
			spotHeight="100"
		/>
	);

	return (
		<div
			className="text-center mb-4"
			data-testid="search-unavailable-illustration"
		>
			<div className="my-4" data-testid="search-unavailable-svg">
				{searchUnavailableSvg}
			</div>
		</div>
	);
};

export default SearchUnavailableIllustration;
